import { FC, useState } from "react";

import importFailure from "../../../assets/fonts/importFailure.svg";
import { Notification } from "../../../types/global/types";
import { useTranslation } from "../../../hooks/useTranslation";
import "./styles.scss";

type Props = {
  notification: Notification;
};

export const RouteDivisionFailedNotification: FC<Props> = ({ notification }) => {
  const { p, t } = useTranslation("notifications");
  const data = notification.notes as any;
  const [copied, setCopied] = useState(false);

  // Error Details - always show the same user-friendly message
  const errorMessage = p("route_division_failed_message");

  // Extract technical error details for support
  const errorDetails: string | null =
    typeof data === "object" && data !== null
      ? (data.error_details || data.message || null)
      : null;

  const handleCopyErrorDetails = () => {
    if (errorDetails) {
      navigator.clipboard.writeText(errorDetails);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="notification">
      {/* Header: icon + title + timestamp */}
      <div className="notification__header">
        <div className="notification__reaction">
          <img src={importFailure} alt="failure" />
        </div>
        <div className="notification__title" style={{ width: "-webkit-fill-available" }}>
          <h3>{p("route_division_failed")}</h3>
          <div className="notification__time">
            {notification.created_at_formatted}
          </div>
        </div>
      </div>

      {/* Error details */}
      <div className="notification__notes">
        <div className="notification__notes-header">{t("common.error_details")}</div>
        <div className="notification__notes-body">{errorMessage}</div>
      </div>

      {/* Technical error information for support */}
      {errorDetails && (
        <div className="notification__notes">
          <div className="notification__notes-header">
            {p("technical_information")}
            <button
              onClick={handleCopyErrorDetails}
              style={{
                marginLeft: "8px",
                padding: "4px 8px",
                fontSize: "12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "transparent",
                cursor: "pointer",
                color: copied ? "green" : "inherit",
              }}
            >
              {copied ? t("common.copied") : t("common.copy")}
            </button>
          </div>
          <div
            className="notification__notes-body"
            style={{
              fontFamily: "monospace",
              fontSize: "12px",
              padding: "8px",
              backgroundColor: "#f5f5f5",
              borderRadius: "4px",
              wordBreak: "break-word",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {errorDetails}
          </div>
        </div>
      )}
    </div>
  );
};
